import getEnvironment from '../utils/env';
import type { Environments } from '../utils/env';

export function getAuth0Base(env: Environments = getEnvironment()) {
  return env === 'stage' ? 'https://proxy.stage-play-aws.tv2net.dk' : 'https://proxy.web.tv2api.dk';
}

export function getAuth0ClientId(env: Environments = getEnvironment()) {
  return env === 'stage' ? 'rx3r6fAdL0YjjJUdh10mefuYWu8Wk4TM' : 'A5PNK2MNdZDFIer3IELxehJjeLHkHvbE';
}
